"use client";

import { useToast } from "hooks/useToast";
import { useCallback, useEffect, useState } from "react";
import { ToastMessage, ToastProps } from "../ToastMessage";
import "./style.css";

function ToastContainer() {
  const [messages, setMessages] = useState<ToastProps[]>([]);

  const { showToast } = useToast();

  useEffect(() => {
    function handleAddToast(event: CustomEventInit) {
      const {
        label,
        message,
        type,
        duration,
        urlImage,
        urlNotification,
      }: Omit<ToastProps, "id"> = event.detail;
      showToast &&
        setMessages((prevState) => [
          {
            id: Date.now(),
            label,
            message,
            type,
            duration,
            urlImage,
            urlNotification,
          },
          ...prevState,
        ]);
    }
    if (typeof window !== "undefined") {
      document.addEventListener("addtoast", handleAddToast);
    }

    return () => {
      if (typeof window !== "undefined") {
        document.removeEventListener("addtoast", handleAddToast);
      }
    };
  }, [showToast]);

  const handleRemoveMessage = useCallback((id: number) => {
    setMessages((prevState) => prevState.filter((item) => item.id !== id));
  }, []);

  return (
    <div className="toast-container">
      {messages.map((item) => (
        <ToastMessage
          key={item.id}
          id={item.id}
          label={item.label}
          message={item.message}
          type={item.type}
          duration={item.duration}
          urlImage={item.urlImage}
          urlNotification={item.urlNotification}
          onRemoveMessage={handleRemoveMessage}
        />
      ))}
    </div>
  );
}

export default ToastContainer;
